(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bdb-cookie-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('bdb-cookie-banner-copy');
    if (!config) return;

    const copy = JSON.parse(config.textContent);
    const selectors = '#shopify-pc__banner, #shopify-pc__prefs';
    const watched = new WeakSet();
    let queued = false;
    let activeModal = null;
    let scrollPosition = null;
    let returnFocus = null;
    const inertBackground = new Set();
    const backdrop = document.createElement('div');
    backdrop.id = 'bdb-cookie-backdrop';
    backdrop.hidden = true;
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.append(backdrop);

    function isVisible(element) {
      return element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
    }

    function getActiveModal() {
      const preferences = document.getElementById('shopify-pc__prefs');
      const banner = document.getElementById('shopify-pc__banner');
      return isVisible(preferences) ? preferences : isVisible(banner) ? banner : null;
    }

    function restoreBackground() {
      inertBackground.forEach(element => { element.inert = false; });
      inertBackground.clear();
    }

    function disableBackground(modal) {
      let branch = modal;
      while (branch && branch !== document.body) {
        [...branch.parentElement.children].forEach(element => {
          if (element !== branch && element !== backdrop && !element.inert && !element.matches('script, style, link')) {
            element.inert = true;
            inertBackground.add(element);
          }
        });
        branch = branch.parentElement;
      }
    }

    function syncModal(modal) {
      if (modal && !activeModal) {
        scrollPosition = { x: window.scrollX, y: window.scrollY };
        returnFocus = modal.contains(document.activeElement) ? null : document.activeElement;
        document.body.style.setProperty('--bdb-cookie-scroll-top', `-${scrollPosition.y}px`);
      }
      if (modal !== activeModal) restoreBackground();
      activeModal = modal;
      document.documentElement.classList.toggle('bdb-cookie-ui-open', Boolean(modal));
      backdrop.hidden = !modal || modal.id !== 'shopify-pc__banner';
      if (modal) {
        disableBackground(modal);
        if (modal.id === 'shopify-pc__banner' && !modal.contains(document.activeElement)) {
          modal.focus({ preventScroll: true });
        }
      } else if (scrollPosition) {
        document.body.style.removeProperty('--bdb-cookie-scroll-top');
        window.scrollTo({ left: scrollPosition.x, top: scrollPosition.y, behavior: 'instant' });
        scrollPosition = null;
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
        returnFocus = null;
      }
    }

    function enhanceBanner(banner) {
      if (banner.dataset.bdbCompact === 'true') return;
      const title = banner.querySelector('#shopify-pc__banner__body-title');
      const paragraph = banner.querySelector('.shopify-pc__banner__body p');
      const buttons = banner.querySelector('.shopify-pc__banner__btns');
      const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
      const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
      const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
      const policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
      if (!title || !paragraph || !buttons || !accept || !decline || !preferences || !policy) return;

      title.textContent = copy.title;
      const withdraw = document.createElement('span');
      withdraw.className = 'bdb-cookie-withdraw';
      withdraw.textContent = copy.withdraw;
      policy.classList.add('bdb-cookie-policy');
      policy.textContent = copy.policy;
      if (new URL(policy.href).pathname === window.location.pathname) {
        document.documentElement.classList.add('bdb-cookie-policy-page');
      }
      buttons.append(accept, preferences, decline, policy);
      paragraph.replaceChildren(document.createTextNode(copy.body), withdraw);
      banner.setAttribute('aria-modal', 'true');
      banner.tabIndex = -1;
      banner.dataset.bdbCompact = 'true';
    }

    function sync() {
      queued = false;
      const elements = [...document.querySelectorAll(selectors)];
      elements.forEach(element => {
        if (element.id === 'shopify-pc__banner') enhanceBanner(element);
        if (!watched.has(element)) {
          visibilityObserver.observe(element, {
            attributes: true,
            attributeFilter: ['style', 'hidden', 'aria-hidden']
          });
          watched.add(element);
        }
      });
      syncModal(getActiveModal());
    }

    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sync);
    }

    const visibilityObserver = new MutationObserver(schedule);
    const additionsObserver = new MutationObserver(records => {
      const relevant = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && (record.target === document.body || node.matches(selectors) || node.querySelector(selectors))
      ));
      if (relevant) schedule();
    });

    additionsObserver.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('keydown', event => {
      const modal = getActiveModal();
      if (modal?.id !== 'shopify-pc__banner' || event.key !== 'Tab') return;
      const controls = [...modal.querySelectorAll('button:not(:disabled), a[href]')].filter(isVisible);
      if (!controls.length) return;
      const current = controls.indexOf(document.activeElement);
      const next = event.shiftKey
        ? (current <= 0 ? controls.length - 1 : current - 1)
        : (current + 1) % controls.length;
      event.preventDefault();
      requestAnimationFrame(() => {
        if (getActiveModal() === modal) controls[next].focus({ preventScroll: true });
      });
    });
    document.addEventListener('focusin', event => {
      const modal = getActiveModal();
      if (modal?.id === 'shopify-pc__banner' && !modal.contains(event.target)) {
        modal.focus({ preventScroll: true });
      }
    });
    document.addEventListener('visitorConsentCollected', schedule);
    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bdb-product-rating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdb-product-rating')) {
    customElements.define('bdb-product-rating', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-stars-started') || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.setAttribute('data-stars-pending', '');
        this.ratingObserver?.disconnect();
        this.ratingObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) return;
          this.setAttribute('data-stars-started', '');
          this.removeAttribute('data-stars-pending');
          this.ratingObserver.disconnect();
        }, { threshold: 0.5 });
        this.ratingObserver.observe(this);
      }

      disconnectedCallback() {
        this.ratingObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bdb-product-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdb-product-shipping')) {
    customElements.define('bdb-product-shipping', class extends HTMLElement {
      connectedCallback() {
        this.shippingController?.abort();
        this.shippingController = new AbortController();
        document.addEventListener('variant:change', (event) => {
          if (event.target.getAttribute('id') !== this.getAttribute('form')) return;
          const variant = event.detail?.variant;
          this.hidden = !variant || !variant.requires_shipping || variant.price < 3500;
        }, { signal: this.shippingController.signal });
      }

      disconnectedCallback() {
        this.shippingController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bdb-shipping-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdb-shipping-timeline')) {
    customElements.define('bdb-shipping-timeline', class extends HTMLElement {
      connectedCallback() {
        this.timelineController?.abort();
        this.timelineController = new AbortController();
        document.addEventListener('variant:change', (event) => {
          if (event.target.getAttribute('id') !== this.getAttribute('form')) return;
          const variant = event.detail?.variant;
          this.hidden = !variant?.available || !variant?.requires_shipping;
        }, { signal: this.timelineController.signal });

        this.timelineObserver?.disconnect();
        this.timelineObserver = new IntersectionObserver((entries) => {
          const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5);
          this.toggleAttribute('data-in-view', visible);
          if (visible) this.setAttribute('data-line-reveal', '');
        }, { threshold: 0.5 });
        this.timelineObserver.observe(this);

      }

      disconnectedCallback() {
        this.timelineController?.abort();
        this.timelineObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bdb-stock-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdb-stock-status')) {
    customElements.define('bdb-stock-status', class extends HTMLElement {
      connectedCallback() {
        this.stockController?.abort();
        this.stockController = new AbortController();
        document.addEventListener('variant:change', (event) => {
          if (event.target.getAttribute('id') !== this.getAttribute('form')) return;
          const variantId = String(event.detail?.variant?.id ?? '');
          this.querySelectorAll('[data-stock-variant-id]').forEach((row) => {
            row.hidden = row.dataset.stockVariantId !== variantId;
          });
          this.hidden = !this.querySelector('[data-stock-variant-id]:not([hidden])');
        }, { signal: this.stockController.signal });
      }

      disconnectedCallback() {
        this.stockController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdb-cart-rewards')) {
    customElements.define('bdb-cart-rewards', class extends HTMLElement {
      connectedCallback() {
        this.rewardsController?.abort();
        this.rewardsController = new AbortController();
        document.addEventListener('cart:change', (event) => {
          const cart = event.detail?.cart;
          if (!cart || !Array.isArray(cart.items)) return;
          const physicalItems = cart.items.filter((item) => item.requires_shipping);
          this.hidden = physicalItems.length === 0 || cart.currency !== this.dataset.currency;
          if (this.hidden) return;
          const discounts = (cart.cart_level_discount_applications || []).reduce((total, discount) => total + discount.total_allocated_amount, 0);
          const total = Math.max(0, physicalItems.reduce((sum, item) => sum + item.final_line_price, 0) - discounts);
          const shipping = Number(this.dataset.shippingThreshold);
          const gift = Number(this.dataset.giftThreshold);
          const max = Math.max(shipping, gift);
          const money = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: this.dataset.currency });
          let message;
          if (total >= shipping && total >= gift) message = this.dataset.completeMessage;
          else if (total >= shipping) message = this.dataset.giftMessage.replace('[amount]', money.format((gift - total) / 100));
          else message = this.dataset.shippingMessage.replace('[amount]', money.format((shipping - total) / 100));
          this.querySelector('.bdb-cart-rewards__message').textContent = message;
          this.style.setProperty('--reward-progress', Math.min(total / max, 1));
          this.querySelector('[data-goal="shipping"]').dataset.reached = String(total >= shipping);
          this.querySelector('[data-goal="gift"]').dataset.reached = String(total >= gift);
          const progress = this.querySelector('[role="progressbar"]');
          progress.setAttribute('aria-valuenow', Math.min(total, max));
          progress.setAttribute('aria-valuetext', message);
        }, { signal: this.rewardsController.signal });
      }

      disconnectedCallback() {
        this.rewardsController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
